<template>
  <div class="tracking-history-wrapper">
    <div class="history-btn" :class="{open: trackingHistory}" @click="openTrackingHistory">
        <i class="icon icon--heatmap-time-history"></i>
        {{ $t('heatmap.journey.trackingHistory.title') }}
    </div>
    <template v-if="isHistoryAlert">
      <div class="history-alert-icon" v-btf-tooltip="{ contents: $t('heatmap.journey.trackingHistory.tooltip'), textAlign: 'center'}">
          <i class="icon icon--warning"></i>
      </div>
    </template>
    <div v-if="trackingHistory" class="history-popup-wrapper"  :style="{ '--arrow': arrowPos + 'px' }">
      <div class="popup-close" @click="trackingHistory = false">
        <i class="icon icon--inquire-x size-20"></i>
      </div>
      <div class="title"> {{ $t('heatmap.journey.trackingHistory.title') }}</div>
      <div class="desc-list">
        <div class="desc-item"> {{ $t('heatmap.journey.trackingHistory.descList[0]') }}</div>
        <div class="desc-item"> {{ $t('heatmap.journey.trackingHistory.descList[1]') }}</div>
      </div>
        <div class="chart-area" :style="{ 'width': '100%' }">
          <div class="legend">
            <div class="legend-mark"></div>
            <div class="legend-name"> {{ $t('heatmap.journey.trackingHistory.legend') }}</div>
          </div>
          <AppChart v-if="isChartData" class="app-chart"
                  mode="dark"
                  :chartOptions="historyChartOpt"
                  :width="'100%'"
                  :height="'180px'"
                  key="historyChart"
                  chartType="bar"
          />
        </div>
    </div>
  </div>
</template>

<script>
import { getHeatmapDailyPvList } from '@/api/group'
import { format, parse } from 'date-fns'
import AppChart from '@/components/chart'

export default {
  name: 'TrackingHistory',
  components: {
    AppChart
  },
  props: {
    heatmapInfo: {
      type: Object
    },
    aid: {
      type: String,
      require: true
    },
    periodDate: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      isChartData: false,
      trackingHistoryData: [],
      trackingHistory: false,
      isHistoryAlert: false,
      arrowPos: 0,
      historyChartOpt: {
        grid: {
          top: 20,
          left: 10,
          right: 10,
          bottom: 10
        },
        legend: {
          show: false
        },
        series: [{
          barWidth: 10,
          data: [],
          itemStyle: {
            barBorderRadius: 5,
            color: '#EC0047'
          },
          name: '페이지 PV(노드 전체)',
          type: 'bar'
        }],
        tooltip: {
          trigger: 'axis',
          confine: true,
          backgroundColor: '#000',
          padding: 15,
          extraCssText: 'border: 0; border-radius: 8px; box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(255, 255, 255, 0.16);',
          textStyle: {
            color: '#c1c1c1',
            fontSize: 12
          },
          axisPointer: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.25)'
            }
          },
          formatter: (params, ticket) => {
            return `${params[0].value[0]}<br /> <span style="color: #EC0047; font-weight: 700">${params[0].value[1]} PV</span>`
          }
        },
        xAxis: {
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            formatter: (value, index) => {
              return format(parse(value), 'MM-DD')
            },
            padding: [10, 10, 10, 10]
          }
        }
        // yAxis: {
        //   axisLabel: {
        //     formatter: (value, index) => {
        //       return Math.floor(value) > 0 ? Math.floor(value) :
        //     },
        //   }
        // }
      },
      historyAlert: false
    }
  },
  created () {
    this.getTrackingHistory()
  },
  methods: {
    getTrackingHistory () {
      const requestData = {
        aid: this.aid,
        startDate: this.periodDate.start,
        endDate: this.periodDate.end,
        parentSid: this.heatmapInfo.parentSid,
        serviceType: 'ba',
        isChart: true
      }
      getHeatmapDailyPvList(requestData, true).then(result => {
        this.isHistoryAlert = result.list.length > result.analysisDaily
        this.trackingHistoryData = result.list
        this.isChartData = true
      }).catch(error => {
        console.error(error)
      })
    },
    openTrackingHistory (e) {
      this.arrowPos = this.getArrowPosition(e)
      this.trackingHistory = !this.trackingHistory
      if (this.trackingHistory) {
        this.historyChartOpt.series[0].data = this.trackingHistoryData
      }
    },
    getArrowPosition (e) {
      const wW = window.innerWidth
      const targetPos = e.target.getBoundingClientRect()
      return Math.round(wW / 2 - (targetPos.left + (targetPos.width / 2)))
    }
  }
}
</script>

<style lang="scss" scoped>
.tracking-history-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  .history-btn {
    cursor: pointer;
    color: #494949;
    font-size: 12px;
    line-height: 1;
    padding: 8px 12px;
    border: 1px solid #D4D4D4;
    border-radius: 24px;
    margin: 0 8px;
    display: inline-flex;
    align-items: center;
    &.open {
      background-color: rgba(0, 0, 0, .06);
    }
    i {
      transform: translateX(-4px);
    }
  }
  .history-alert-icon {
    cursor: pointer;
    i {
      vertical-align: middle;
    }
  }
  .history-popup-wrapper {
    --arrow: 0;
    position: fixed;
    top: 90px;
    left: 100px;
    display: flex;
    width: 740px;
    // height: 316px
    padding: 25px;
    flex-direction: column;
    justify-content: space-between;
    gap: 15px;
    flex-shrink: 0;
    border-radius: 14px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16), 0px 8px 15px 0px rgba(0, 0, 0, 0.16);
    z-index: 100;
    color: #fff;
    background-color: #1B1B1D;
    box-sizing: border-box;
    margin-top: 10px;
    .title  {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 15px;
    }
    .desc-list {
      color: #bbb;
      font-size: 12px;
      line-height: 1.4;
      .desc-item {
        padding-bottom: 4px;
      }
    }
    .chart-area {
      position: relative;
      .legend {
        position: absolute;
        bottom: 100%;
        right: 0;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        gap: 5px;
        &-mark {
          width: 12px;
          height: 12px;
          background-color: #EC0047;
          border-radius: 50%;
        }
        &-name {
          color: #bbb;
          font-size: 12px;
          line-height: 1.5;
        }
      }
    }
    &:after {
      content: '';
      position: absolute;
      width: 15px;
      height: 10px;
      bottom: 100%;
      left: calc(50% - 90px - var(--arrow));
      background-color: #1B1B1D;
      clip-path: polygon(0 100%, 50% 0, 100% 100%);
      margin: -1px;
    }
    .popup-close {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      top: 10px;
      right: 10px;
      &:hover {
        background: rgba(255, 255, 255, 0.25);
      }
    }
  }
}
</style>
